
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'view-organizations-show-organization-history'
})
